import React from 'react'
import './LoanCard.css'

const LoanCard = ({ applicant, amount, repaymentPeriod, applicationDate, status }) => {
  return (
    <div className='loan-profile-container'>
        <div className='loan-details'>
            <h3>{applicant}</h3>
            <div className='loan-info'>
              <p>Amount: {amount}</p>
              <p>Repayment Period: {repaymentPeriod}</p>
              <div className='application-date'>
                <span>Application Date:</span>
                <span> {applicationDate}</span>
              </div>
            </div>
        </div>
        <div className='loan-status'>
          {status}
        </div>
    </div>
  )
}

export default LoanCard